import { render, staticRenderFns } from "./LeaderCard.vue?vue&type=template&id=0575fcef&"
import script from "./LeaderCard.vue?vue&type=script&lang=js&"
export * from "./LeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./LeaderCard.vue?vue&type=style&index=0&id=0575fcef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports